import React from 'react';
import ReactDOM from 'react-dom/client';
import { initMercadoPago } from '@mercadopago/sdk-react';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const mercadoPagoPublicKey = process.env.REACT_APP_MERCADOPAGO_PUBLIC_KEY;
if (mercadoPagoPublicKey) {
  initMercadoPago(mercadoPagoPublicKey, { locale: 'pt-BR' });
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
